// extracted by mini-css-extract-plugin
export default {"textShieldRoot":"textShieldRoot___SlIaY","s":"s___GuZEl","m":"m___r12nG","l":"l___AYk6L","static":"static____CmkA","textShieldImg":"textShieldImg___t9Wo3"};